export default __webpack_public_path__ + "static/media/Blacksting.f6e3e5d6.jpg";